export enum ScreenBreakpointTypes{
    ExtraSmall = '300px',
    Small = '576px',
    Medium = '768px',
    Large = '992px',
    ExtraLarge = '1200px'
}